import commonExtend from '../common/exted';
export default [...commonExtend];